import React, { useEffect, useState } from 'react';
// Redux
import { useSelector } from 'react-redux';

import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Payout.css';

// Component
import PayoutList from './PayoutList';
import EmptyList from './PayoutList/EmptyList';
import Loader from '../Loader';

const Payout = ({ currentAccountId }) => {

  const data = useSelector(state => state.payout.data);
  const loading = useSelector(state => state.payout.getPayoutLoading);

  const [initialLoad, setInitialLoad] = useState(true)

  useEffect(() => {
    setInitialLoad(false)
  }, [initialLoad]);

  if (loading && initialLoad) return <Loader type={"text"} />;

  if (data?.length == 0) return <EmptyList />

  return <PayoutList data={data} currentAccountId={currentAccountId} />;

}

Payout.defaultProps = {
  loading: true,
  data: []
}

export default withStyles(s)(Payout);